import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  toggle() {
    this.submitTarget.disabled = !this.element.querySelector("input[type='checkbox']").checked
  }
}
